import executeRequest from "./request.js";
export const post = async (url, data, signal) => {
    const response = await executeRequest(url, "POST", data);
    return response;
};
